// Map Style Icons - Custom SVG components (no emoji)

interface IconProps {
  className?: string;
}

// Streets - road with dashed center line
export function StreetsIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round">
      <path d="M7 3v3M17 3v3M7 9v3M17 9v3M7 15v3M17 15v3M7 21v-1" />
      <rect x="3" y="2" width="18" height="20" rx="2.5" strokeWidth={1.6} />
      <path d="M12 5v2M12 11v2M12 17v2" strokeDasharray="0.1 3" strokeWidth={2.2} />
    </svg>
  );
}

// Light - sun
export function LightIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round">
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 2v2.5M12 19.5V22M4.22 4.22l1.77 1.77M18.01 18.01l1.77 1.77M2 12h2.5M19.5 12H22M4.22 19.78l1.77-1.77M18.01 5.99l1.77-1.77" />
    </svg>
  );
}

// Dark - moon
export function DarkIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

// OpenStreetMap - globe
export function OsmIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9.5" />
      <path d="M2.5 12h19M12 2.5c2.4 2.6 3.6 5.9 3.6 9.5S14.4 18.9 12 21.5c-2.4-2.6-3.6-5.9-3.6-9.5S9.6 5.1 12 2.5z" />
    </svg>
  );
}

// Satellite - satellite dish
export function SatelliteIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M6.4 6.4a8.5 8.5 0 0 0 9.2 9.2" />
      <path d="M4.2 4.2a12 12 0 0 0 13 13" opacity={0.45} />
      <path d="M13.5 13.5 21 21" />
      <circle cx="13.5" cy="13.5" r="2.2" />
      <path d="M17 3.5 20.5 7" opacity={0.6} />
      <path d="M16 6.5 19.5 10" opacity={0.4} />
    </svg>
  );
}

// Hybrid - satellite + labels overlay
export function HybridIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M6.4 6.4a8.5 8.5 0 0 0 9.2 9.2" />
      <path d="M13.5 13.5 21 21" />
      <circle cx="13.5" cy="13.5" r="2.2" />
      <rect x="2.5" y="2.5" width="9" height="5" rx="1.4" />
      <path d="M4.5 5h5" />
    </svg>
  );
}

// Topo / outdoors - contour lines + tree
export function TopoIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 16.5c2.5-2.6 5-2.6 7.5 0s5 2.6 7.5 0 4-2.2 5-1.6" />
      <path d="M2 12c2.5-2.6 5-2.6 7.5 0s5 2.6 7.5 0 4-2.2 5-1.6" opacity={0.7} />
      <path d="M2 20.5c2.5-2.6 5-2.6 7.5 0s5 2.6 7.5 0 4-2.2 5-1.6" opacity={0.5} />
      <path d="M17 3.5 20 8.5h-6z" />
    </svg>
  );
}

// Terrain - mountains
export function TerrainIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 19h20" />
      <path d="M2 19l6.5-11 4.5 7.5" />
      <path d="M12 19l5-8.5 5 8.5" />
      <path d="M8.5 8 10 5.2 11.5 8" opacity={0.55} />
    </svg>
  );
}

// Heatmap - heat waves
export function HeatmapIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round">
      <path d="M12 3c-2.5 2.2-3.8 4.4-3.8 7 0 2 .9 3.2 1.9 4.2" opacity={0.5} />
      <path d="M12 6.5c-1.4 1.5-2.1 2.9-2.1 4.6 0 1.4.6 2.3 1.4 3" opacity={0.75} />
      <circle cx="12" cy="17" r="3.2" />
      <path d="M12 15.6v2.8M10.8 16.8h2.4" />
    </svg>
  );
}

// 3D buildings - stacked blocks
export function Buildings3DIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21V9.5L8 7v14" />
      <path d="M8 21V11.5l4.5-2V21" />
      <path d="M12.5 21v-8L17 11.2V21" />
      <path d="M17 21V13.5L21 12v9" />
      <path d="M1.5 21h21" />
      <path d="M5.5 11.5h0M5.5 14.5h0M10.5 13h0M10.5 16h0M15 15h0" opacity={0.6} />
    </svg>
  );
}